var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-3 mb-5"},[[_c('span',{staticClass:"content"},[_vm._v("No "+_vm._s(_vm.detailName)+" details available")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }